import API_BASE_URL from "../config";

async function login({ email, password }) {
  const response = await fetch(`${API_BASE_URL}/login`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email, password }),
  });

  const result = await response.json();
  if (!response.ok) {
    throw new Error(result.message || "Login failed");
  }

  return result;
}

async function register({ firstName, lastName, email, password }) {
  const response = await fetch(`${API_BASE_URL}/register`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ firstName, lastName, email, password }),
  });

  const result = await response.json();
  if (!response.ok) {
    throw new Error(result.message || "Registration failed");
  }

  return result;
}

async function verifyOtp({ email, otp }) {
  const response = await fetch(`${API_BASE_URL}/verify-otp`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email, otp }),
  });

  const result = await response.json();
  if (!response.ok) {
    throw new Error(result.message || "OTP verification failed");
  }

  return result;
}

export { login, register, verifyOtp };
